export default function Header() {
    return (
        <>
            <section className='menutop'>
                <div className='container-fluid'>
                    <div className='row justify-content-center' style={{ alignItems: "center" }}>
                        <div className='col-md-5'>
                            <div className='row justify-content-center'>
                                <div className='col-md-5 col-12' style={{ paddingLeft: "10px", paddingRight: "0px" }}>
                                    <center><p><i className="fa-solid fa-phone" /> : +91-9876543210</p></center>
                                </div>
                                <div className='col-md-7 col-12' style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                                    <center><p><i className="fa-solid fa-envelope" /> : info@sarkariresultexam.com</p></center>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2 col-4'>
                            <center><img src="01.png" className="Apogo" alt="logo" /></center>
                        </div>
                        <div className='col-md-5'>
                            <div className='row justify-content-center'>
                                <div className='col-md-6 col-12'>
                                    <div className="position-relative">
                                        <input className="form-control search-input mt-2" type="search" placeholder="Search" aria-label="Search" style={{ borderRadius: "20px" }}
                                        />
                                        <i className="bi bi-search search-icon" />
                                    </div>
                                </div>
                                <div className='col-md-3 col-7 ii'>
                                    <center><p className='btn btn-danger btn-block mt-2' style={{ borderRadius: "20px", fontSize: 12, color: "#fff" }}>GET STARTED</p></center>
                                </div>
                                <div className='col-md-3 col-3'>
                                    {/* <center><img src="02.png" className="App-logo" alt="logo" width="100%" /></center> */}
                                    <center><p className='btn btn-danger btn-block mt-2' style={{ borderRadius: "20px", fontSize: 12, color: "#fff" }}>OFFERS</p></center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='sticky-top'>
                <div className='container'>
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
                        ><span className="navbar-toggler-icon" /></button>
                        <i className="wew text-white fa-brands fa-facebook" />
                        <i className="wew text-white fa-brands fa-twitter" />
                        <i className="wew text-white fa-brands fa-instagram" />
                        <i className="wew text-white fa-brands fa-linkedin" />
                        <i className="wew text-white fa-brands fa-youtube" />
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item active vv">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} exact href="/"> Home <span className="sr-only">(current)</span></a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} exact href="/about">About Us</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} href="/">Test Series</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} href="/">Exam</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} href="/">Youtube Video</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} href="/">Help</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link text-left" style={{ paddingLeft: "10px" }} href="/contact">Contact Us</a>
                                </li>
                            </ul>
                            <i className="ewe text-white fa-brands fa-facebook" />
                            <i className="ewe text-white fa-brands fa-twitter" />
                            <i className="ewe text-white fa-brands fa-instagram" />
                            <i className="ewe text-white fa-brands fa-linkedin" />
                            <i className="ewe text-white fa-brands fa-youtube" />
                            <a className="nav-link text-left" href="/" style={{ color: "#fff", background: "#e40612", textAlign: "center", borderRadius: "40px", paddingLeft: "10px", fontWeight: "600" }}>Subscription</a>
                        </div>
                    </nav>
                </div>
            </section>
        </>
    )
}